import config from 'config';

export const getSecretKey = (): string | null | undefined => {
  if (import.meta.env.VITE_SYNCBAK_SECRET_KEY) {
    return import.meta.env.VITE_SYNCBAK_SECRET_KEY;
  }
  const platform = config.platformName;
  if (platform === 'vizio') {
    return import.meta.env.VITE_SYNCBAK_SECRET_KEY_VIZIO;
  }
  if (platform === 'lg-webos') {
    return import.meta.env.VITE_SYNCBAK_SECRET_KEY_LG;
  }
  if (platform === 'samsung-tizen') {
    return import.meta.env.VITE_SYNCBAK_SECRET_KEY_SAMSUNG;
  }

  return null;
};
